import { render, staticRenderFns } from "./PortalContent.vue?vue&type=template&id=688d1d56"
import script from "./PortalContent.vue?vue&type=script&lang=js"
export * from "./PortalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports